import React from "react";
import HorizontalArray from "./HorizontalArray";
import VerticalArray from "./VerticalArray";

const ArrayFields = ({component, path, parentPath, index}) => {
    const {properties: {arrayType}, children} = component;
    //TODO make component fieldArray draggable
    return (
        <div>
            {arrayType === 'vertical' ? (
                <VerticalArray
                    column={children}
                    path={path}
                    parentPath={parentPath}
                    index={index}
                />
            ) : (
                <HorizontalArray
                    children={children && children.length ? children : []}
                    path={path}
                    parentPath={parentPath}
                />
            )}
        </div>
    )
};

export default ArrayFields;